export const maskedGridColumnType = {
    PHONENUMBR: 1,
    PERCENTAGE: 2,
    MONEY: 3,
    FAXNUMBER: 4,
    CREDITCARD: 5,
    ZIPCODE: 6,
    SSN: 7,
}